.footer {
  display: block;
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  text-align: center;
  background: #f9f9f9;

  @media screen and (width >= 768px) {
    display: none;
  }
}

.content {
  display: inline-block;
  padding: 24px 0;
}

.linkList {
  display: flex;
}

.linkItem {
  & + & {
    margin-left: 40px;
  }
}

.contactList {
  margin-top: 24px;
  text-align: center;
}

.contactItem {
  & + & {
    margin-top: 24px;
  }
}

.copyright {
  display: block;
  margin-top: 24px;
}
